// extracted by mini-css-extract-plugin
module.exports = {"container":"e_1o","placeholder":"e_2o","embed":"e_3o"};